import { useState } from "react";
import axios from "axios";
import { API } from "@/lib/api";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { username, password });
      onLogin(res.data.token, res.data.username, res.data.default_creds);
    } catch (err) {
      setError(err?.response?.data?.detail || "تعذر تسجيل الدخول — حاول مجدداً");
    }
    setLoading(false);
  };

  return (
    <div className="login-page" dir="rtl">
      <div className="bg-glow" />
      <div className="login-card" data-testid="login-card">
        <div className="brand-badge">
          <span className="brand-dot" /> TWIN TC LLC
        </div>
        <h1 className="login-title">
          نظام مراقبة سيرفر <span className="grad">Ookla</span>
        </h1>
        <p className="login-sub">سجّل دخولك للوصول للوحة المراقبة</p>

        <form onSubmit={submit} className="login-form">
          <label className="field-label">اسم المستخدم</label>
          <input
            className="field-input"
            dir="ltr"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="username"
            required
            data-testid="login-username-input"
          />

          <label className="field-label">كلمة المرور</label>
          <input
            className="field-input"
            dir="ltr"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••"
            autoComplete="current-password"
            required
            data-testid="login-password-input"
          />

          {error && (
            <div className="login-error" data-testid="login-error">
              ✖ {error}
            </div>
          )}

          <button className="btn btn-primary login-btn" type="submit" disabled={loading} data-testid="login-submit-btn">
            {loading ? <span className="spinner" /> : "\uD83D\uDD10"} {loading ? "جاري الدخول..." : "تسجيل الدخول"}
          </button>
        </form>
      </div>
    </div>
  );
}
